// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".menu__item[data-v-8bd4a49e]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
